// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__wd7kr","additionalInfo":"AgreementModal_additionalInfo__3Ti-c"};